import { InAppPackage } from "../../types/mailcredit";
import { generateAPI } from "../api.generator";

export const getAllInAppPackages = generateAPI<{}, InAppPackage[]>("get", "mail-credits/in-app-package/all");
